import Vue from 'vue'
import Router from 'vue-router'

// import HelloWorld from '@/components/HelloWorld'

const HomePage = () => import("@/views/home/index")
const accountReceivable = () => import("@/views/home/accountReceivable")
const accountUnGetMeterBill = () => import("@/views/home/accountUnGetMeterBill")
const accountUnpaid = () => import("@/views/home/accountUnpaid")
const accountFlowWater = () => import("@/views/home/accountFlowWater")
const accountReceipt = () => import("@/views/home/accountReceipt")
const statisticalReport = () => import("@/views/home/statisticalReport")
const summaryTable = () => import("@/views/home/summaryTable")
const summaryTableList = () => import("@/views/home/summaryTableList")
const summaryTableAdd = () => import("@/views/home/summaryTableAdd")
const summaryTableInfo = () => import("@/views/home/summaryTableInfo")
const summaryTableReadMeter = () => import("@/views/home/summaryTableReadMeter")

const tenant = () => import("@/views/home/tenant")
const tenantInfo = () => import("@/views/home/tenantInfo")
const tenantRenewal = () => import("@/views/home/tenantRenewal")
const tenantRoom = () => import("@/views/home/tenantRoom")
const tenantAdd = () => import("@/views/home/tenantAdd")
const tenantAddNext = () => import("@/views/home/tenantAddNext")
const tenantComplete = () => import("@/views/home/tenantComplete")
const tenantExpired = () => import("@/views/home/tenantExpired")
const tenantSelectHouse = () => import("@/views/home/tenantSelectHouse")
const tenantHouseInfo = () => import("@/views/home/tenantHouseInfo")
const tenantHistory = () => import("@/views/home/tenantHistory")

const owner = () => import("@/views/home/owner")
const ownerHistory = () => import("@/views/home/ownerHistory")
const ownerExpire = () => import("@/views/home/ownerExpire")
const ownerAdd = () => import("@/views/home/ownerAdd")
const ownerBillList = () => import("@/views/home/ownerBillList")
const ownerInfo = () => import("@/views/home/ownerInfo")
const ownerSelectHouse = () => import("@/views/home/ownerSelectHouse")
const ownerBillDetail = () => import("@/views/home/ownerBillDetail")
const ownerBillConfirm = () => import("@/views/home/ownerBillConfirm")
const ownerBillAdd = () => import("@/views/home/ownerBillAdd")

const IdleRoom = () => import("@/views/home/IdleRoom")
const IdleRoomTenant = () => import("@/views/home/IdleRoomTenant")
const IdleRoomCheck = () => import("@/views/home/IdleRoomCheck")
const IdleRoomEdit = () => import("@/views/home/IdleRoomEdit")
const HistoryTenant = () => import("@/views/home/historyTenant")
const billList = () => import("@/views/home/billList")
const billAdd = () => import("@/views/home/billAdd")
const billAddOther = () => import("@/views/home/billAddOther")
const billRent = () => import("@/views/home/billRent")
const billDetail = () => import("@/views/home/billDetail")
const billDetailOther = () => import("@/views/home/billDetailOther")
const billReadMeter = () => import("@/views/home/billReadMeter")
const billProgress = () => import("@/views/home/billProgress")
const billConfirm = () => import("@/views/home/billConfirm")

const readMeterCenter = () => import("@/views/home/readMeterCenter")
const readMeterDetail = () => import("@/views/home/readMeterDetail")
const readMeterProgress = () => import("@/views/home/readMeterProgress")

// 房产模块(添加)
const houseIndex = () => import("@/views/houseProperty/houseIndex")
const addHouse = () => import("@/views/houseProperty/addHouse")

const accountList = () => import("@/components/accountList")

const AddAccount = () => import("@/views/houseProperty/addAccount")
const addRoomNumber = () => import("@/views/houseProperty/addRoomNumber")
const housePhoto = () => import("@/views/houseProperty/housePhoto")
const RoomConfig = () => import("@/views/houseProperty/roomConfig")
const CustomConfig = () => import("@/views/houseProperty/customConfig")
const batchAddRoom = () => import("@/views/houseProperty/batchAddRoom")
const batchConfigList = () => import("@/views/houseProperty/batchConfigList")
const batchConfigItem = () => import("@/views/houseProperty/batchConfigItem")
const ApplyRoom = () => import("@/views/houseProperty/applyRoom")
const selectHouse = () => import("@/components/selectHouse")

const selectPosition = () => import("@/components/selectPosition")

const SearchPosition = () => import("@/views/houseProperty/searchPosition")
// 房产模块(管理)
const RoomNumberList = () => import("@/views/manageHouses/roomNumberList")
const EditHouse = () => import("@/views/manageHouses/editHouse")
// const TenantList = () => import("@/views/manageHouses/tenantList")
//
// const RoomDetails = () => import("@/views/manageHouses/roomDetails")
// const ViewRoomPhoto = () => import("@/views/manageHouses/viewRoomPhoto")
// const EditRoom = () => import("@/views/manageHouses/editRoom")


const hire = () => import("@/views/home/hire")
const hireList = () => import("@/views/home/hireList")
const hireDetail = () => import("@/views/home/hireDetail")
const hiretypelist = () => import("@/views/home/hiretypelist")

//我的
const my_index = () => import("@/views/my/index")
const putForward = () => import("@/views/my/putForward")
const putForwardList = () => import("@/views/my/putForwardList")
const info = () => import("@/views/my/info")
const login = () => import("@/views/my/login")
const contract = () => import("@/views/my/contract")
const smart = () => import("@/views/my/smart")
const viewLock = () => import("@/views/my/viewLock")
const selectRoom = () => import("@/views/my/selectRoom")
const help = () => import("@/views/my/help")
const notice = () => import("@/views/my/notice")
const wordsDetail = () => import("@/views/my/wordsDetail")
const accountBill = () => import("@/views/my/accountBill")
const meterlog = () => import("@/views/my/meterlog")

Vue.use(Router)

let env = process.env.NODE_ENV
const router = new Router({
  // mode:'history',
  // base:'/view/',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/globalSearch',
      name: 'globalSearch',
      component: () => import('@/components/search'),
      meta: {
        cache: true,
      },
    },
    {
      path: '/accountReceivable',
      name: 'accountReceivable',
      component: accountReceivable,
      meta: {
        cache: true
      }
    },
    {
      path: '/accountUnGetMeterBill',
      name: 'accountUnGetMeterBill',
      component: accountUnGetMeterBill,
      meta: {
        cache: true
      }
    },
    {
      path: '/accountUnpaid',
      name: 'accountUnpaid',
      component: accountUnpaid,
      meta: {
        cache: true
      }
    },
    {
      path: '/accountFlowWater',
      name: 'accountFlowWater',
      component: accountFlowWater,
      meta: {
        cache: true
      }
    },
    {
      path: '/accountReceipt',
      name: 'accountReceipt',
      component: accountReceipt,
      meta: {
        cache: true
      }
    },
    {
      path: '/statisticalReport',
      name: 'statisticalReport',
      component: statisticalReport,
      meta: {
        cache: true
      }
    },
    {
      path: '/summaryTable',
      name: 'summaryTable',
      component: summaryTable,
      meta: {
        cache: true
      }
    },
    {
      path: '/summaryTableList',
      name: 'summaryTableList',
      component: summaryTableList,
      meta: {
        cache: true
      }
    },
    {
      path: '/summaryTableAdd',
      name: 'summaryTableAdd',
      component: summaryTableAdd,
      meta: {
        cache: true
      }
    },
    {
      path: '/summaryTableInfo',
      name: 'summaryTableInfo',
      component: summaryTableInfo,
      meta: {
        cache: true
      }
    },
    {
      path: '/summaryTableReadMeter',
      name: 'summaryTableReadMeter',
      component: summaryTableReadMeter,
    },
    {
      path: '/tenant',
      name: 'tenant',
      component: tenant,
      meta: {
        cache: true
      }
    },
    {
      path: '/owner',
      name: 'owner',
      component: owner,
      meta: {
        cache: true
      }
    },
    {
      path: '/ownerHistory',
      name: 'ownerHistory',
      component: ownerHistory,
      meta: {
        cache: true
      }
    },
    {
      path: '/ownerExpire',
      name: 'ownerExpire',
      component: ownerExpire,
      meta: {
        cache: true
      }
    },
    {
      path: '/ownerAdd',
      name: 'ownerAdd',
      component: ownerAdd,
      meta: {
        cache: true
      }
    },
    {
      path: '/ownerBillList',
      name: 'ownerBillList',
      component: ownerBillList,
    },
    {
      path: '/ownerInfo',
      name: 'ownerInfo',
      component: ownerInfo,
      meta: {
        cache: true
      }
    },
    {
      path: '/ownerSelectHouse',
      name: 'ownerSelectHouse',
      component: ownerSelectHouse,
    },
    {
      path: '/ownerBillDetail',
      name: 'ownerBillDetail',
      component: ownerBillDetail,
    },
    {
      path: '/ownerBillConfirm',
      name: 'ownerBillConfirm',
      component: ownerBillConfirm,
    },
    {
      path: '/ownerBillAdd',
      name: 'ownerBillAdd',
      component: ownerBillAdd,
    },
    {
      path: '/billList',
      name: 'billList',
      component: billList,
      meta: {
        cache: true
      }
    },
    {
      path: '/billAddOther',
      name: 'billAddOther',
      component: billAddOther,
      meta: {
        cache: true
      }
    },
    {
      path: '/billRent',
      name: 'billRent',
      component: billRent,
    },
    {
      path: '/billAdd',
      name: 'billAdd',
      component: billAdd,
      meta: {
        cache: true
      }
    },
    {
      path: '/billDetail',
      name: 'billDetail',
      component: billDetail,
      meta: {
        cache: true
      }
    },
    {
      path: '/billDetailOther',
      name: 'billDetailOther',
      component: billDetailOther,
      meta: {
        cache: true
      }
    },
    {
      path: '/billReadMeter',
      name: 'billReadMeter',
      component: billReadMeter,
      meta: {
        cache: true
      }
    },
    {
      path: '/billProgress',
      name: 'billProgress',
      component: billProgress,
    },
    {
      path: '/billConfirm',
      name: 'billConfirm',
      component: billConfirm,
      meta: {
        cache: true
      }
    },
    {
      path: '/readMeterCenter',
      name: 'readMeterCenter',
      component: readMeterCenter,
    },
    {
      path: '/readMeterDetail',
      name: 'readMeterDetail',
      component: readMeterDetail,
      meta: {
        cache: true
      }
    },
    {
      path: '/readMeterProgress',
      name: 'readMeterProgress',
      component: readMeterProgress,
    },
    {
      path: '/tenantInfo',
      name: 'tenantInfo',
      component: tenantInfo,
      meta: {
        cache: true
      }
    },
    {
      path: '/tenantRenewal',
      name: 'tenantRenewal',
      component: tenantRenewal
    },
    {
      path: '/tenantRoom',
      name: 'tenantRoom',
      component: tenantRoom,
    },
    {
      path: '/tenantAdd',
      name: 'tenantAdd',
      component: tenantAdd,
      meta: {
        cache: true
      }
    },
    {
      path: '/tenantAddNext',
      name: 'tenantAddNext',
      component: tenantAddNext,
      meta: {
        cache: true
      }
    },
    {
      path: '/tenantComplete',
      name: 'tenantComplete',
      component: tenantComplete,
      meta: {
        cache: true
      }
    },
    {
      path: '/tenantExpired',
      name: 'tenantExpired',
      component: tenantExpired,
    },
    {
      path: '/tenantSelectHouse',
      name: 'tenantSelectHouse',
      component: tenantSelectHouse,
      meta: {
        cache: true
      }
    },
    {
      path: '/tenantHouseInfo',
      name: 'tenantHouseInfo',
      component: tenantHouseInfo,
    },
    {
      path: '/tenantHistory',
      name: 'tenantHistory',
      component: tenantHistory,
    },
    {
      path: '/IdleRoom',
      name: 'IdleRoom',
      component: IdleRoom,
      meta: {
        cache: true
      },
    },
    {
      path: '/IdleRoomTenant',
      name: 'IdleRoomTenant',
      component: IdleRoomTenant,
      meta: {
        cache: true
      },
    },
    {
      path: '/IdleRoomCheck',
      name: 'IdleRoomCheck',
      component: IdleRoomCheck,
      meta: {
        cache: true
      },
    },
    {
      path: '/IdleRoomEdit',
      name: 'IdleRoomEdit',
      component: IdleRoomEdit,
      meta: {
        cache: true
      },
    },
    {
      path: '/houseIndex',
      name: 'houseIndex',
      component: houseIndex,
      meta: {
        cache: true
      },
    },
    {
      path: '/addHouse',
      name: 'addHouse',
      component: addHouse,
      meta: {
        cache: true
      },
    },
    {
      path: '/selectHouse',
      name: 'selectHouse',
      component: selectHouse
    },
    {
      path: '/selectPosition',
      name: 'selectPosition',
      component: selectPosition,
      children: [
        {
          path: '/searchPosition',
          name: 'SearchPosition',
          component: SearchPosition,
        }
      ]
    },
    {
      path: '/accountList',
      name: 'accountList',
      component: accountList,
      children: [
        {
          path: '/addAccount',
          name: 'AddAccount',
          component: AddAccount,
        }
      ]
    },
    {
      path: '/addRoomNumber',
      name: 'addRoomNumber',
      component: addRoomNumber,
      meta: {
        cache: true
      },
    },
    {
      path: '/housePhoto',
      name: 'housePhoto',
      component: housePhoto,
      meta: {
        cache: true
      },
    },
    {
      path: '/roomConfig',
      name: 'RoomConfig',
      component: RoomConfig,
    },
    {
      path: '/customConfig',
      name: 'CustomConfig',
      component: CustomConfig,
    },
    {
      path: '/batchAddRoom',
      name: 'batchAddRoom',
      component: batchAddRoom,
      meta:{
        cache: true
      }
    },
    {
      path: '/batchConfigList',
      name: 'batchConfigList',
      component: batchConfigList,
      meta:{
        cache: true
      }
    },
    {
      path: '/batchConfigItem',
      name: 'batchConfigItem',
      component: batchConfigItem,
      meta:{
        cache: true
      }
    },
    {
      path: '/batchHousePhoto',
      name: 'BatchHousePhoto',
      component: housePhoto
    },
    {
      path: '/batchRoomConfig',
      name: 'BatchRoomConfig',
      component: RoomConfig,
    },
    {
      path: '/batchCustomConfig',
      name: 'BatchCustomConfig',
      component: CustomConfig,
    },
    {
      path: '/applyRoom',
      name: 'ApplyRoom',
      component: ApplyRoom,
    },
    {
      path: '/hire',
      name: 'hire',
      component: hire,
      meta:{
        cache: true
      }
    },
    {
      path: '/hireList',
      name: 'hireList',
      component: hireList,
      meta:{
        cache: true
      }
    },
    {
      path: '/hiretypelist',
      name: 'hiretypelist',
      component: hiretypelist,
      meta:{
        cache: true
      }
    },
    {
      path: '/hireDetail',
      name: 'hireDetail',
      component: hireDetail,
      meta:{
        cache: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/contract',
      name: 'contract',
      component: contract,
    },
    {
      path: '/smart',
      name: 'smart',
      component: smart,
    },
    {
      path: '/viewLock',
      name: 'viewLock',
      component: viewLock,
    },
    {
      path: '/selectRoom',
      name: 'selectRoom',
      component: selectRoom,
    },
    {
      path: '/help',
      name: 'help',
      component: help,
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
    },
    {
      path: '/wordsDetail',
      name: 'wordsDetail',
      component: wordsDetail,
    },
    {
      path: '/accountBill',
      name: 'accountBill',
      component: accountBill,
    },
    {
      path: '/meterlog',
      name: 'meterlog',
      component: meterlog,
    },
    {
      path: '/my',
      name: 'my',
      component: my_index
    },
    {
      path: '/info',
      name: 'info',
      component: info,
    },
    {
      path: '/putForward',
      name: 'putForward',
      component: putForward,
      meta: {
        cache: true
      },
    },
    {
      path: '/putForwardList',
      name: 'putForwardList',
      component: putForwardList
    },
    {
      path: '/roomNumberList',
      name: 'RoomNumberList',
      component: RoomNumberList,
      meta: {
        cache: true
      },
    },
    {
      path: '/editHouse',
      name: 'EditHouse',
      component: EditHouse,
      meta: {
        cache: true
      },
    },
    {
      path: '/editOfAccountList',
      name: 'EditOfAccountList',
      component: accountList,
    }, {
      path: '/editOfaddAccount',
      name: 'EditOfAddAccount',
      component: AddAccount,
    }, {
      path: '/selectHouse',
      name: 'selectHouse',
      component: selectHouse,
    }, {
      path: '/selectPosition',
      name: 'selectPosition',
      component: selectPosition,
    }, {
      path: '/accountList',
      name: 'accountList',
      component: accountList,
    },
  ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js